import axios from 'axios'
import { URL_BACKEND, getUsuario } from './Configuracoes'
import { mostrarToast } from '../components/Toasts'
import { mensagens } from '../util/Utilitarios'
import { getConfig, logout, reload, minutosEmInatividade } from '../util/Configuracoes'
import { ACOES, MODULO } from './Enums'
import ls from 'local-storage'
import moment from "moment"

const obterInstancia = () => {
    if (window.location.href.indexOf('recuperarsenha') < 0 && window.location.href.indexOf('usuarioexterno') < 0 && minutosEmInatividade() > 60) {
        logout()
        reload()
        return;
    }
    let user = getUsuario();
    let instance = axios.create({
        headers: {
            'Authorization': user && user.token ? getUsuario().token : ''
        }
    })

    return instance
}

const obterInstanciaExterno = () => {
    let instance = axios.create({
        headers: {
            'Access-Control-Allow-Origin': 'http://localhost:3000',
        }
    })

    return instance
}

const atulizarWs = (data, url, modulo) => {
    const user = getUsuario()

    data.auditoria = {
        usuario: user && user.id,
        modulo: modulo,
        controle: data.id,
        acao: ACOES.IMPORTAR
    }

    put(url, data, true)
}

const salvar = (data, url, sucessoFunction, erroFunction, naoMostrarErro, acao) => {
    setarUltimaHoraLogin();
    const user = getUsuario()

    data.auditoria = {
        usuario: user && user.id,
        modulo: MODULO[url.toLowerCase()],
        controle: data.id
    }

    console.log('acao', acao)

    if (data.id) {
        data.auditoria.acao = acao || ACOES.ALTERAR
        Promise.resolve(
            put(url, data, true, naoMostrarErro))
            .then(data => sucessoFunction && sucessoFunction(data))
            .catch(erro => erroFunction && erroFunction(erro))
    } else {
        data.auditoria.acao = acao || ACOES.INSERIR
        Promise.resolve(
            post(url, data, true, naoMostrarErro))
            .then(data => sucessoFunction && sucessoFunction(data))
            .catch(erro => { erroFunction && erroFunction(erro); })
    }
}

const acoesAgenda = (data, url, sucessoFunction, erroFunction, naoMostrarErro, acao, modulo) => {
    const user = getUsuario()

    data.auditoria = {
        usuario: user && user.id,
        modulo: modulo && modulo || MODULO[url.toLowerCase()],
        controle: data.id
    }

    switch (acao) {
        case ACOES.CANCELAR_AGENDA:
            data.auditoria.acao = ACOES.CANCELAR_AGENDA
            Promise.resolve(
                put(url, data, true, naoMostrarErro))
                .then(data => sucessoFunction && sucessoFunction(data))
                .catch(erro => erroFunction && erroFunction(erro))
            break
        case ACOES.PREFERENCIAL:
            data.auditoria.acao = ACOES.PREFERENCIAL
            Promise.resolve(
                post(url, data, true, naoMostrarErro))
                .then(data => sucessoFunction && sucessoFunction(data))
                .catch(erro => erroFunction && erroFunction(erro))
            break
        case ACOES.OBSERVACAO_AGENDA:
            data.auditoria.acao = ACOES.OBSERVACAO_AGENDA
            Promise.resolve(
                put(url, data, true, naoMostrarErro))
                .then(data => sucessoFunction && sucessoFunction(data))
                .catch(erro => erroFunction && erroFunction(erro))
            break
        case ACOES.FINALIZAR_AGENDA:
            data.auditoria.acao = ACOES.FINALIZAR_AGENDA
            Promise.resolve(
                put(url, data, true, naoMostrarErro))
                .then(data => sucessoFunction && sucessoFunction(data))
                .catch(erro => erroFunction && erroFunction(erro))
            break
        case ACOES.CONFIRMAR_AGENDA:
            data.auditoria.acao = ACOES.CONFIRMAR_AGENDA
            Promise.resolve(
                put(url, data, true, naoMostrarErro))
                .then(data => sucessoFunction && sucessoFunction(data))
                .catch(erro => erroFunction && erroFunction(erro))
            break
        case ACOES.ALTERAR_STATUS_AGENDA:
            data.auditoria.acao = ACOES.ALTERAR_STATUS_AGENDA
            Promise.resolve(
                put(url, data, true, naoMostrarErro))
                .then(data => sucessoFunction && sucessoFunction(data))
                .catch(erro => erroFunction && erroFunction(erro))
            break
    }
}

const setarUltimaHoraLogin = () => {
    try {
        ls.set('ultimo_hora_login', moment())
    } catch (error) {
        console.log('error', error)
    }
}

const putComAcao = (acao, modulo, data, url, sucessoFunction, erroFunction, naoMostrarErro) => {
    setarUltimaHoraLogin();

    const user = getUsuario()

    data.auditoria = {
        usuario: user && user.id,
        modulo: modulo || MODULO[url.toLowerCase()],
        controle: data.id || data.controle
    }
    data.auditoria.acao = acao
    Promise.resolve(
        put(url, data, true, naoMostrarErro))
        .then(data => sucessoFunction && sucessoFunction(data))
        .catch(erro => erroFunction && erroFunction(erro))
}

const excluir = async (url, id, sucessoFunction, erroFunction) => {
    setarUltimaHoraLogin();
    const user = getUsuario()
    const data = {
        auditoria: {
            usuario: user && user.id,
            modulo: MODULO[url.toLowerCase()],
            acao: ACOES.EXCLUIR,
            controle: id
        },
        ...id
    }
    let instance = obterInstancia();
    await instance.delete(URL_BACKEND + url + "/" + id, { params: { ...data, ...id } }, getConfig())
        .then(data => sucessoFunction && sucessoFunction(data))
        .catch(erro => erroFunction && erroFunction(erro))
}

const validaCadastro = async (url, finalUrl, dados, sucessoFunction, erroFunction) => {
    const user = getUsuario()
    dados.auditoria = {
        usuario: user && user.id,
        modulo: MODULO[url.toLowerCase()],
        acao: ACOES.VALIDAR,
        controle: dados.id
    }

    Promise.resolve(
        put(url + finalUrl, dados, true))
        .then(data => { sucessoFunction && sucessoFunction(data) })
        .catch(erro => { erroFunction && erroFunction(erro) })

}

const reenvioDados = async (url, finalUrl, dados, sucessoFunction, erroFunction) => {
    const user = getUsuario()
    dados.auditoria = {
        usuario: user && user.id,
        modulo: MODULO[url.toLowerCase()],
        acao: ACOES.REENVIAR,
        controle: dados.id
    }

    Promise.resolve(
        put(finalUrl, dados, true))
        .then(data => sucessoFunction && sucessoFunction(data))
        .catch(erro => erroFunction && erroFunction(erro))

}


const visualizar = (url, id, sucess, error) => {
    const user = getUsuario()
    const data = {
        id,
        auditoria: {
            usuario: user && user.id,
            modulo: MODULO[url.toLowerCase()],
            acao: ACOES.VISUALIZAR,
            controle: id
        }
    }

    get(url + '/' + id, data, true).then(data => sucess && sucess(data)).catch(erro => error && error(erro))
}

const emitirRelatorio = (url, titulo, filtros, sucess, error) => {
    const user = getUsuario()
    const data = {
        filtros,
        auditoria: {
            usuario: user && user.id,
            modulo: MODULO[url.toLowerCase()],
            acao: ACOES.EMITIR_RELATORIO,
            controle: titulo
        }
    }

    get(url, data, true).then(data => sucess && sucess(data)).catch(erro => error && error(erro))
}

const consultar = (url, sucessoFunction, erroFunction, parametros) => {
    const user = getUsuario()
    const data = {
        auditoria: {
            usuario: user && user.id,
            modulo: MODULO[url.toLowerCase()],
            acao: ACOES.CONSULTAR,
            tipo: user && user.tipo
        },
        ...parametros
    }

    get(url, data, true)
        .then(data => sucessoFunction && sucessoFunction(data, parametros))
        .catch(erro => erroFunction && erroFunction(erro))
}

const consultarFiltros = (url, sucessoFunction, erroFunction, filtros) => {
    const user = getUsuario()
    const data = {
        colunasFiltros: {
            filtros
        }
        // auditoria: {
        //     usuario: user && user.id,
        //     modulo: MODULO[url.toLowerCase()],
        //     acao: ACOES.CONSULTAR,
        //     tipo: user && user.tipo
        // },
        // ...parametros
    }

    get(url, data, true)
        .then(data => sucessoFunction && sucessoFunction(data))
        .catch(erro => erroFunction && erroFunction(erro))
}




const pesquisarDataGrid = (url, sucessoFunction, erroFunction, pesquisa, ordenamento, filtros, ordenamentoModal, limit) => {
    const data = {
        parametroPesquisa: {
            pesquisa
        },
        parametroOrdenamento: {
            ordenamento
        },
        parametroFiltro: {
            filtros,
            limit: limit
        },
        parametrosOrdenamentoModal: {
            ordenamentoModal
        }

    }

    consultar(url, dataNew => sucessoFunction && sucessoFunction(dataNew), erro => erroFunction && erroFunction(erro), data)
}

const post = async (url, body, autenticado, naoMostrarErro, externo) => {
    setarUltimaHoraLogin();
    naoMostrarErro = naoMostrarErro === true ? true : false
    let instance = externo ? obterInstanciaExterno() : obterInstancia();

    return await instance.post(URL_BACKEND + url, body, autenticado && getConfig())
        .then(res => {
            return res.data
        })
        .catch(e => {
            try {
                JSON.parse(e.response.data.erros).forEach((item) => naoMostrarErro === false && mostrarToast('erro', item))
            } catch (e2) {
                if (e.response && e.response.data && e.response.data.erros)
                    e.response.data.erros.forEach((item) => naoMostrarErro === false && mostrarToast('erro', item))
                else
                    naoMostrarErro === false && mostrarToast('erro', mensagens.erro)

                throw e
            }
            throw e
        })
}



const put = async (url, data, autenticacao, naoMostrarErro) => {
    setarUltimaHoraLogin();
    naoMostrarErro = naoMostrarErro === true ? true : false
    let instance = obterInstancia();
    await instance.put(URL_BACKEND + url, data, autenticacao && getConfig())
        .then(res => res.data)
        .catch(e => {
            try {
                JSON.parse(e.response.data.erros).forEach((item) => naoMostrarErro === false && mostrarToast('erro', item))
            } catch (e2) {
                if (e.response && e.response.data && e.response.data.erros)
                    e.response.data.erros.forEach((item) => naoMostrarErro === false && mostrarToast('erro', item))
                else
                    naoMostrarErro === false && mostrarToast('erro', mensagens.erro)

                throw e
            }
            throw e
        })
}

const get = (url, data, autenticacao) => {

    let instance = obterInstancia()

    return instance.get(URL_BACKEND + url, data && { params: data }, autenticacao && getConfig())
        .then(res => {
            return res.data;
        }).catch(e => {
            console.log('', URL_BACKEND + url + e)
        })
    // .catch(errorFunction ? errorFunction() : e => {
    //     if (e.response.status === 401) {
    //         logout()
    //         reload()
    //     }
    //     if (e.response && e.response.data && e.response.data.erros || e.response.status === 401) {
    //         e.response.data.erros.forEach((item) => mostrarToast('erro', item))

    //     }
    //     else
    //         mostrarToast('erro', mensagens.erro)
    //     return {}
    // })
}

const validar = async (url, data, callbackSuccess, callbackError) => {
    let instance = obterInstancia();

    await instance.get(URL_BACKEND + url, data && { params: data }, getConfig())
        .then(e => callbackSuccess && callbackSuccess(e)).catch(e => callbackError && callbackError(e))
}
const validarComPost = async (url, data, callbackSuccess, callbackError) => {
    let instance = obterInstancia();

    await instance.post(URL_BACKEND + url, data, getConfig())
        .then(e => callbackSuccess && callbackSuccess(e)).catch(e => callbackError && callbackError(e))
}

const getApiExterna = (url, callbackSuccess, callbackError) => {
    const instance = obterInstanciaExterno()

    return axios.get(url)
        .then(e => callbackSuccess && callbackSuccess(e))
        .catch(e => callbackError && callbackError(e))
}

const postApiExterna = (url, data, callbackSuccess, callbackError) => {
    const instance = obterInstanciaExterno()

    return instance.post(url, data, instance)
        .then(e => callbackSuccess && callbackSuccess(e))
        .catch(e => callbackError && callbackError(e))
}

export {
    post, put, get, getApiExterna, salvar, putComAcao, excluir, visualizar, consultar, validar, obterInstancia, validaCadastro,
    postApiExterna, reenvioDados, atulizarWs, consultarFiltros, pesquisarDataGrid, acoesAgenda, validarComPost, emitirRelatorio
}